import type { CSSProperties, FC, ReactElement } from "react"

import { AnimatePresence, m } from "framer-motion"
import { useScrollbarWidth } from "react-use"

import { WaveLoader } from "@/3514/components/shared/loadable/loaders/wave-loader/wave-loader.component"
import { EWaveLoaderVariant } from "@/3514/components/shared/loadable/loaders/wave-loader/wave-loader.types"
import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"

type TProps = { top?: CSSProperties["top"]; xsTop?: CSSProperties["top"] }
const RootLoaderFallback: FC<TProps> = ({ top = "15%", xsTop = "15%" }: TProps): ReactElement => {
    const scrollbarWidth: number = useScrollbarWidth()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const actualTop: CSSProperties["top"] = breakpoints.xs || breakpoints.sm ? xsTop : top

    return (
        <AnimatePresence presenceAffectsLayout>
            <m.div
                initial={{ scale: 0.9, opacity: 0.9, top: actualTop }}
                animate={{
                    scale: 1,
                    opacity: 1,
                    top: actualTop
                }}
                exit={{ scale: 0.9, opacity: 0.9 }}
                layout
                layoutId="root-loader"
                transition={{ duration: 0.3 }}
                style={{
                    position: "fixed",
                    left: breakpoints.xs || breakpoints.sm ? "50%" : `calc(50% - ${scrollbarWidth}px)`,
                    translate: "-50% -50%",
                    zIndex: 9999
                }}
            >
                <WaveLoader cssIdentifier="root-loader" withRelativePosition variant={EWaveLoaderVariant.LightBlue} />
            </m.div>
        </AnimatePresence>
    )
}

export { RootLoaderFallback }
